const locale = {
  id: 'FinanceConstant',
  code: 'CN',
  text: {
    "./images/finance-en.png": "./images/finance-cn.png",
    'Real-Time Accurate Financial Management': '实时精确的财务管理',
    'Here you can view all of your school’s payment details and monthly summary. You can easily filter your income and expenditure details and send transaction records to parents and students.': '您可以在这查看您学校所有的收支明细以及月度汇总。您可以对收支明细方便地进行筛选，还可以给家长学生发送交易记录。',
  }
}

export const onBoardingContents = {
  title: __('Real-Time Accurate Financial Management', locale),
  text: __('Here you can view all of your school’s payment details and monthly summary. You can easily filter your income and expenditure details and send transaction records to parents and students.', locale),
  image: require(__('./images/finance-en.png', locale)),
  showArrow: false,
}



// WEBPACK FOOTER //
// ./src/containers/tables/FinanceTable/constant.js